import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject, input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, AbstractControl } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-app/shared/control-value-accessor-validator-base';
import { IOnboardingSection } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding.d';
import { FiOnboardingBuilderHelperService } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-builder-helper.service';
import { Animations } from '@fi-shared/utils/animations';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FiOnboardingElementDropListHelperService } from '../fi-onboarding-element-drop-list-helper.service';

@Component({
    selector: 'fi-onboarding-sections-list',
    templateUrl: './fi-onboarding-sections-list.component.html',
    styleUrls: ['./fi-onboarding-sections-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-sections-editor' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiOnboardingSectionsListComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiOnboardingSectionsListComponent,
            multi: true,
        },
    ],
    standalone: false,
    animations: [Animations.fadeHeight()],
})
export class FiOnboardingSectionsListComponent extends ControlValueAccessorValidatorBase<IOnboardingSection[]> {
    private fiOnboardingBuilderHelperService = inject(FiOnboardingBuilderHelperService);
    private fiOnboardingElementDropListHelperService = inject(FiOnboardingElementDropListHelperService);
    public isViewMode = input<boolean>();

    protected deleteSection(sectionIndex: number): void {
        const sectionStepsCount = this.ngModel[sectionIndex].Steps.length;
        for (let i = 0; i < sectionStepsCount; i++) {
            this.fiOnboardingElementDropListHelperService.removeStepElementDropListId(sectionIndex, i);
        }
        this.ngModel.splice(sectionIndex, 1);
        this.doPropagateChanges();
    }

    protected addSection(): void {
        this.ngModel.push(this.fiOnboardingBuilderHelperService.getNewOnboardingSectionInstance());
        this.fiOnboardingElementDropListHelperService.addStepElementDropListId(this.ngModel.length - 1, 0);
        this.doPropagateChanges();
    }

    protected onElementDrop($event: CdkDragDrop<IOnboardingSection[]>): void {
        if ($event.previousContainer === $event.container) {
            moveItemInArray($event.container.data, $event.previousIndex, $event.currentIndex);
        }
    }

    public doValidate(c: AbstractControl): ValidationErrors {
        return {
            'missing-sections': !this.ngModel?.length,
            'missing-active-sections': !this.ngModel?.filter((section: IOnboardingSection) => !section.IsDisabled)
                .length,
        };
    }
}
